import { IOption } from 'components/Select/type';

// Title values are BE-defined: Mr./Mrs./Fam./Other
export const titleOptions: IOption[] = [
  { value: 'Mr.', label: 'Mr.' },
  { value: 'Mrs.', label: 'Mrs.' },
  { value: 'Fam.', label: 'Fam.' },
  { value: 'Other', label: 'Other' },
];
